<template>
  <div class="mall-goods__head">
    <div class="mall-goods__image">
      <img :src="goods.coverImg" alt="">
    </div>
    <div class="mall-goods__info">
      <div class="mall-goods__title" v-if="title">{{title}}</div>
      <p class="mall-goods__desc" v-if="goods.goodsDesc">{{goods.goodsDesc}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MallGoodsInfo',
  props: {
    goods: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    title() {
      return this.goods.title || this.goods.name;
    }
  }
};
</script>

<style lang="stylus" scoped>
.mall-goods__head {
  display: flex;
  .mall-goods__image {
    width: 50px;
    height: 66px;
    margin-right: 12px;
    background: #D8D8D8;
    border-radius: 5px;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .mall-goods__info {
    flex: 1;
    width: 100px;
  }
  .mall-goods__title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #41414D;
    line-height: 22px;
  }
  .mall-goods__desc {
    font-size: 12px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #a1a1b3;
    line-height: 16px;
    margin-top: 5px;
  }
}

</style>